import { useEffect, useRef } from 'react';
import { IframeMessageReceiver } from './IframeMessageReceiver';
export var useMessageReceiver = function (expectedOriginUrl, type, receiver) {
    var _a;
    return useMessageReceivers(expectedOriginUrl, (_a = {}, _a[type] = receiver, _a));
};
export var useMessageReceivers = function (expectedOriginUrl, receivers) {
    var receiver = useRef(null);
    useEffect(function () {
        if (!expectedOriginUrl) {
            return;
        }
        receiver.current = IframeMessageReceiver.create(expectedOriginUrl, receivers);
        return function () {
            // eslint-disable-next-line
            receiver.current.dispose();
        };
    }, [expectedOriginUrl]);
    return receiver;
};
